import { Text } from '@wix/design-system';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { Gift } from '@wix/wix-ui-icons-common/lazy';
import React from 'react';
import { BaseVoucherBanner } from '../../Components/VoucherBanner/VoucherBanner';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
export const AccountGateVoucherBanner = () => {
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t,
    Trans = _DomainSearchGateModu.Trans;
  const _DomainsApiClient$hoo = DomainsApiClient.hooks.useDomainsAccount({}),
    data = _DomainsApiClient$hoo.data,
    isLoading = _DomainsApiClient$hoo.isLoading;
  if (isLoading) {
    return null;
  }
  return /*#__PURE__*/React.createElement(BaseVoucherBanner, {
    icon: /*#__PURE__*/React.createElement(Gift, null),
    content: data != null && data.hasValidVouchers ? /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "domain_search_gate.voucher_banner",
      components: [/*#__PURE__*/React.createElement(Text, {
        size: "small",
        weight: "bold"
      })]
    }) : t('domains_search_gate.revamp.free_site.banner')
  });
};
//# sourceMappingURL=AccountGateVoucherBanner.js.map